import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useLayout } from '../../contexts/LayoutContext';

// Chevron pointing left — means "collapse" (nav is open, click to close)
const ChevronLeft = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

// Chevron pointing right — means "expand" (nav is closed, click to open)
const ChevronRight = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const TenantHeader = ({ userProfile = null, loading = false }) => {
  const { navCollapsed, toggleNav } = useLayout();

  const tenantName = userProfile?.tenant?.name || 'Loading...';
  const isOpen = !navCollapsed;

  return (
    <div className="tenant-header">
      {isOpen && (
        <Link to="/app/" className="tenant-name-link">
          <h2 className="tenant-name">
            {loading ? 'Loading...' : tenantName}
          </h2>
        </Link>
      )}
      <button
        className="nav-toggle-btn"
        onClick={toggleNav}
        aria-label={isOpen ? 'Collapse navigation' : 'Expand navigation'}
      >
        {isOpen ? <ChevronLeft /> : <ChevronRight />}
      </button>
    </div>
  );
};

TenantHeader.propTypes = {
  userProfile: PropTypes.shape({
    tenant: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  loading: PropTypes.bool,
};

export default TenantHeader;